import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faQrcode, faMoneyCheckDollar, faMinus, faPlus, faBuilding, faJournalWhills, faCashRegister } from '@fortawesome/free-solid-svg-icons';
import './LifeResources.css';
import liferesourcesimage from '../../assets/pageimages/LifeResources.webp';

function LifeResourcesHome() {

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>LifeResources</h2>
      </div>
      <div className="main-content">
      <div className="top-section top-section mt-4 ml-2 mr-0 border border-b-gray-300">
          <div className="button-links flex align-middle justify-center bg-gray-500">
            <div className="bottom-buttons-box"><Link to="/liferesources-payments" className="top-button-link"><FontAwesomeIcon icon={faMinus} className="liferesources-bottomlink-style" />Payments</Link></div>
            <div className="bottom-buttons-box"><Link to="/liferesources-receipts" className="top-button-link"><FontAwesomeIcon icon={faPlus} className="liferesources-bottomlink-style" />Receipts</Link></div>
            <div className="bottom-buttons-box"><Link to="/liferesources-assets" className="top-button-link"><FontAwesomeIcon icon={faBuilding} className="liferesources-bottomlink-style" />Assets</Link></div>
            <div className="bottom-buttons-box"><Link to="/liferesources-journal" className="top-button-link"><FontAwesomeIcon icon={faJournalWhills} className="liferesources-bottomlink-style" />Journal</Link></div>
            <div className="bottom-buttons-box"><Link to="/liferesources-contra" className="top-button-link"><FontAwesomeIcon icon={faCashRegister} className="liferesources-bottomlink-style" />Contra</Link></div>
            <div className="bottom-buttons-box"><Link to="/liferesources-returnable" className="top-button-link"><FontAwesomeIcon icon={faStar} className="liferesources-bottomlink-style" />Returnable</Link></div>
          </div>
        </div>
        <div className="image-container">
          <div className="relative inset-0 flex border border-b-gray-300">
            <img id="liferesources-id" src={liferesourcesimage} alt="LifeResources Image" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default LifeResourcesHome;
